<template>
  <v-dialog v-model="dialog" v-bind="$attrs" class="cms-page-dialog-container">
    <v-card>
      <slot name="header"></slot>
      <slot name="errors" v-bind="errors">
        <v-card-text v-if="errors.length" class="py-5">
          <base-alert type="error">{{
            $t('actions.pageCouldNotLoad')
          }}</base-alert>
        </v-card-text>
      </slot>
      <slot name="cms" v-bind="page">
        <v-card-text class="pa-0 ma-0" style="color: inherit">
          <cms-page
            v-if="!loading && !errors.length && page"
            :content="page.cmsPage"
            :class="contentClass"
          ></cms-page>
        </v-card-text>
      </slot>
      <slot name="loading" v-bind="loading">
        <v-card-text v-if="loading" class="text-center">
          <v-progress-circular
            :size="80"
            color="grey-darken-4"
            indeterminate
            class="mx-auto my-5"
          ></v-progress-circular>
        </v-card-text>
      </slot>
      <slot name="actions">
        <v-card-actions class="pa-0">
          <base-button
            block
            large
            class="cms-page-dialog-container__action text-body-4"
            @click="dialog = false"
          >
            <base-icon mdi="close" small class="mr-1"></base-icon>
            {{ $t('actions.close') }}
          </base-button>
        </v-card-actions>
      </slot>
    </v-card>

    <template #activator="attr">
      <slot name="activator" v-bind="attr"></slot>
    </template>
  </v-dialog>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import { useCmsPage } from '~/composables'
import BaseAlert from '~/components/base/alert/BaseAlert'
import BaseIcon from '~/components/base/icon/BaseIcon'
import BaseButton from '~/components/base/button/BaseButton'

export default {
  name: 'CmsPageDialogContainer',
  components: {
    BaseButton,
    BaseIcon,
    BaseAlert,
    CmsPage: () => import('~/components/cms/CmsPage'),
  },
  props: {
    pageUrl: {
      type: String,
      default: '',
    },
    contentClass: {
      type: [String, Array],
      default: 'ma-5 ma-sm-8 ma-md-10',
    },
  },
  setup(props, { root }) {
    const { errors, page, cmsPage, loading, search } = useCmsPage(root)

    const dialog = ref(false)

    watch(dialog, (dialog) => {
      if (dialog) {
        search(props.pageUrl)
      }
    })

    return {
      dialog,

      errors,
      page,
      loading,
      cmsPage,
    }
  },
}
</script>

<style lang="scss">
@import '~vuetify/src/styles/styles.sass';

.cms-page-dialog-container {
  &__action {
    background-color: map-get($shades, 'grey-lighten-3') !important;

    @media #{map-get($display-breakpoints, 'md-and-up')} {
      background-color: map-get($shades, 'beige-pastel-light') !important;
    }
  }
}
</style>
